module.exports = __webpack_public_path__ + "static/img/orderTops.8695f689.png";